<template>
  <div class="leaderboard-box">
    <div class="leaderboard-indicators">
      <van-cell is-link @click="showPopup">
        {{ $t(`personal.referrals.leaderboard.status.${select}`) }}
      </van-cell>
      <van-popup v-model="show" position="bottom" :style="{ height: '25%' }">
        <div
          class="leaderboard-status-button"
          v-for="item in option"
          :key="item.value"
          @click="checkstatus(item.value)"
          >
          {{ $t(`personal.referrals.leaderboard.status.${item.value}`) }}
        </div>
      </van-popup>
    </div>
    <div class="leaderboard-list">
      <div class="list-item self">
        <div class="list-left">
          <p v-show="selfInfo.index > 0" class="index">{{ formatIndex(selfInfo.index) }}</p>
        </div>
        <div class="list-right">
          <div>
            <div class="photo">
              <img
                :src="$DjangoMediaUrl(selfInfo.photo_url)"
                :title="selfInfo.name"
                @error="getDefaultProfilePhoto($event)"
              >
            </div>
            <p class="name">{{ selfInfo.name }}</p>
          </div>
          <p>{{ formatCount(selfInfo.count) }}</p>
        </div>
      </div>
      <div class="list-item" v-for="(item, index) in leaderboardList" :key="index">
        <div class="list-left">
          <p class="index">{{ formatIndex(item.index) }}</p>
        </div>
        <div class="list-right">
          <div>
            <div class="photo">
              <img
                :title="item.name"
                :src="$DjangoMediaUrl(item.photo_url)"
                @error="getDefaultProfilePhoto($event)"
              >
            </div>
            <p class="name">{{ item.name }}</p>
          </div>
          <p>{{ formatCount(item.count) }}</p>
        </div>
      </div>
      <RectLoading v-show="showLoading"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { padStart } from 'lodash'
import RectLoading from '@/components/loading/rectLoading'

export default {
  props: {
    personalInfo: {
      required: true
    },
    companyHiddenRewards: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RectLoading
  },
  data () {
    return {
      select: 'applied',
      leaderboardList: [],
      selfInfo: [],
      show: false,
      showLoading: false
    }
  },
  computed: {
    option () {
      const option = [
        // { value: 'shares' },
        { value: 'submits' },
        { value: 'views' },
        { value: 'applied' },
        { value: 'interviewed' },
        { value: 'onboard' },
        { value: 'probation' }
      ]
      if (!this.companyHiddenRewards) {
        option.push({ value: 'all' })
      }
      return option
    }
  },
  created () {
    this.initData()
  },
  mounted () {

  },
  methods: {
    ...mapActions('personal', ['getMyLeaderBoardData']),
    initData () {
      this.getLeaderBoardData()
    },
    async getLeaderBoardData () {
      this.leaderboardList = []
      this.selfInfo = []
      this.showLoading = true
      try {
        const resp = await this.getMyLeaderBoardData({ status: this.select })
        if (resp) {
          this.leaderboardList = resp.list
          this.selfInfo = resp.self
        }
      } finally {
        this.showLoading = false
      }
    },
    formatCount (data) {
      data = data + ''
      const reg = /(?=(?!\b)(?:\d{3})+(?!\d))/g
      if (data) {
        return data.trim().replace(reg, ',')
      }
      return data
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    },
    formatIndex (index) {
      return padStart(index, '2', '0')
    },
    showPopup () {
      this.show = true
    },
    checkstatus (status) {
      this.select = status
      this.show = false
    }
  },
  watch: {
    select (newVal) {
      this.getLeaderBoardData()
    }
  }
}
</script>

<style lang="scss" scoped>
.leaderboard-box {
  background-color: #FFFFFF;
  padding: 10px 0;
  margin-bottom: 30px;
  border-radius: 5px;

  .leaderboard-indicators {
      margin: 10px 10px;
      text-align: center;
      border-bottom: 1px solid #666666;

      ::v-deep .van-cell {
        justify-content: center;
        align-items: center;

        .van-cell__value--alone {
          flex: unset;
          color: #333333;
        }

        .van-cell__right-icon {
          transform: rotate(90deg);
          margin: -5px 0 0 9px;
          color: #333333;
        }
      }

      .leaderboard-status-button {
        padding: 7px 0;
        border-bottom: 0.5px solid #cacaca;
        font-size: 14px;

        &:last-child {
          border-bottom: 0px;
        }
      }
  }

  .leaderboard-list {
    padding-bottom: 10px;
    position: relative;

    .list-item {
      display: flex;
      justify-content: space-between;
      height: 40px;
      align-items: center;
      border-left: 3px solid #FFFFFF;

      .list-left {
        width: 10%;

        .index {
          width: 20px;
        }

        p {
          padding-left: 10px;
          color: #606266;
        }
      }

      .list-right {
        display: flex;
        width: 90%;
        justify-content: space-between;
        margin-right: 20px;
        border-bottom: 1px solid #d6d6d6;
        align-items: center;
        height: 40px;

        > div {
          display: flex;

          > p {
              padding-left: 10px;
          }
        }
      }
    }

    .self {
      border-left: 3px solid var(--custom-color);
      background-color: #fef9f5;
    }

    .photo {
      padding-top: 5px;

      > img {
        width: 25px;
        height: 25px;
        border-radius: 50%;
      }
    }

    ::v-deep .loading-mask {
      position: absolute;
      display: none;

      .spinner {
        div {
          background-color: var(--custom-color);
        }
      }
    }
  }
}
</style>
